module.exports = __webpack_public_path__ + "media/images/icons/paysafe-7762c26ea1a0eb654ab5cf5449c0711a.svg";